export const FEEDBACK_REASONS = [
  'Incorrect answer',
  "Didn't understand my question",
  'Too slow',
  'Too verbose',
  'Missing details',
  'Not relevant',
  'Confusing',
  'Other',
] as const;

export type FeedbackReason = (typeof FEEDBACK_REASONS)[number];
